import request from "@/shared/config/request";
import { ENDPOINTS } from "@/shared/constants/api";
import {
  ChangeEmailPasswordRequest,
  ExchangeTokenResponse,
  RegisterRequest,
  RequestResetPasswordRequest,
  ResetPasswordRequest,
  SignInRequest,
  SignInResponse,
} from "@/shared/types/auth";
import { User } from "@/shared/types/user";
// import humps from "humps";
export async function signIn(signInRequest: SignInRequest) {
  // const form = new URLSearchParams();
  // const payload = humps.decamelizeKeys(signInRequest) as Record<string, any>;
  // Object.entries(payload).forEach(([k, v]) => {
  //   if (v !== undefined && v !== null && v !== "") form.append(k, String(v));
  // });

  const res = await request.post<SignInResponse>(
    ENDPOINTS.SIGN_IN,
    signInRequest

    // {
    //   headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //   transformRequest: [(d) => d],
    // }
  );

  return res.data;
}

export async function exchangeToken(
  token: string
): Promise<ExchangeTokenResponse> {
  return await request
    .post<ExchangeTokenResponse>(ENDPOINTS.EXCHANGE_TOKEN, { code: token })
    .then((res) => res.data);
}

export async function register(
  RegisterRequest: RegisterRequest
): Promise<User> {
  return await request
    .post<User>(ENDPOINTS.REGISTER, RegisterRequest)
    .then((res) => res.data);
}

export async function requestResetPassword(
  req: RequestResetPasswordRequest
): Promise<string> {
  return await request
    .post<string>(ENDPOINTS.REQUEST_RESET_PASSWORD, req)
    .then((response) => response.data);
}

export async function resetPassword(
  req: ResetPasswordRequest
): Promise<string> {
  return await request
    .post<string>(ENDPOINTS.RESET_PASSWORD, req)
    .then((response) => response.data);
}

export async function changeEmailPassword(
  req: ChangeEmailPasswordRequest
): Promise<string> {
  return await request
    .post<string>(ENDPOINTS.CHANGE_EMAIL_PASSWORD, req)
    .then((response) => response.data);
}
